import { toSnakeCase } from 'case-converter';

export const serialize = obj => (
  Object.entries(toSnakeCase(obj))
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
);



// WEBPACK FOOTER //
// ./src/utils/helpers.js